import { ItemResource, Link } from '@ngx-hal/models';

export class ItemResourceGetBy<Entity extends ItemResource> {
  static readonly type = '[ItemResource] GetBy';

  constructor(readonly link: Link, readonly sample: Partial<Entity>) {}
}

export class ItemResourceCreate<Entity extends ItemResource> {
  static readonly type = '[ItemResource] Create';

  constructor(readonly link: Link, readonly entity: Entity) {}
}

export class ItemResourceRead {
  static readonly type = '[ItemResource] Read';

  constructor(readonly link: Link) {}
}

export class ItemResourceUpdate<Entity extends ItemResource> {
  static readonly type = '[ItemResource] Update';

  constructor(readonly link: Link, readonly entity: Entity) {}
}

export class ItemResourceRemove {
  static readonly type = '[ItemResource] Remove';

  constructor(readonly link: Link) {}
}
